export default __webpack_public_path__ + "static/media/026-street.dac7cb0d.svg";